<template lang="pug">
  .gallery-element(:class="{editable: !disabled, ignored: ignored}")
    .move-button-icon.hover-primary(v-if="!single")
      maximize-2-icon.template-element-tool-move.icon-sm(style="transform:rotate(45deg);")
    .delete-button-icon(@click="$emit('destroy')", v-if="!single")
      trash-2-icon.icon-sm.hover-danger
    fieldset(:disabled="disabled")
      div(style="padding: .7rem;")
        .text(v-for="e_a in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name === 'text'", :id="`element_attribute_${e_a.element_attribute_id}`")
          span(v-if="disabled", :class="!e_a.value ? 'text-secondary' : null") {{ e_a.value || 'Mensaje no definido' }}
          vue-tribute(:options="tributeOpts", v-else)
            b-form-textarea.form-control-flush(no-resize, max-rows="100", placeholder="Mensaje", :value="e_a.value", @input="updateElementAttribute(e_a, $event)")
        .text-template-buttons-container(:id="`element_id_${element_id}_buttons_${disabled}`", v-if="(disabled && Element_Connectors.length) || !disabled")
          button-connector(v-for="(button, button_index) in Element_Connectors", :key="button.element_connector_id", v-bind="button", :block_id="block_id", element, :element_id="element_id", :template_id="template_id", :disabled="disabled")
          button-common(add, v-if="!disabled && Element_Connectors.length < 3", title="Agregar botón +", @click="createElementConnector")
</template>

<script>
import Button from '@/components/templates/connectors/Button.vue'
import ButtonCommon from '@/components/templates/common/Button.vue'
import templateElementCommon from '@/helpers/template-element-common'

import ImageComponent from '@/components/templates/common/Image.vue'

import _debounce from 'lodash.debounce'
import Sortable from 'sortablejs';

// title and subtitle have a limit of 80 chars.

export default {
  props: {
    single: {
      type: Boolean,
      default: false
    }
  },
  mixins: [templateElementCommon],
  methods: {
    templateClasses (element_attribute) {
      return {
        'text-secondary': !element_attribute.value,
        'full-width-template': this.Element_Connectors.length
      }
    },
  },
  components: {
    'button-connector': Button,
    ImageComponent,
    ButtonCommon
  },
  created () {
    this.updateElementAttribute = _debounce((element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      console.log(attribute);
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }, 2000, {leading: false, trailing: true})

    this.createElementConnector = _debounce(() => {
      let connector = {
        title: '',
        type: 'payload',
        number: this.Element_Connectors.length + 1
      }
      this.createConnector(this.block_id, this.template_id, this.element_id, connector)
    }, 0, {leading: false, trailing: true})
  },
  mounted () {
    let self = this

    if (!this.disabled) {
      // element connectors sortable
      var el = document.getElementById(`element_id_${this.element_id}_buttons_${this.disabled}`)
      var sortable = new Sortable(el, {
        handle: '.template-connector-tool-move',
        draggable: '.flow-builder-connector-button',
        direction: 'vertical',
        ghostClass: 'draggable-ghost-class',
        filter: '.not-draggable',
        onMove: function (event) {
          return event.related.className.indexOf('no-sortable') === -1;
        },
        onEnd: function (event) {
          let oldIndex = event.oldIndex
          let newIndex = event.newIndex

          self.$store.commit('block/reorderElementConnectors', {
            block_id: self.block_id,
            template_id: self.template_id,
            element_id: self.element_id,
            oldIndex: oldIndex,
            newIndex: newIndex
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .gallery-element {
    flex: 0 0 auto;
    min-width: 0;
    width: 350px;
    max-width: $template-max-width;
    background-color: $message-bg-light;
    // padding: .7rem;
    border-radius: 1rem;
    color: $dark;
    word-break: break-word;
    position: relative;
    // overflow: hidden;

    &.ignored {
      opacity: 0.7;
      border: 2px dashed $light-white;
    }

    .delete-button-icon, .move-button-icon {
      top: -15px;
      right: -15px;
      width: 30px;
      height: 30px;
      border: 1px solid $secondary;
      opacity: 1;
      z-index: 1;

      position: absolute;
      border-radius: 50%;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: .1s;
      cursor: pointer;
      color: $secondary;
    }

    .move-button-icon {
      right: 20px;
      cursor: move;
    }

    &:not(.editable) {
      .delete-button-icon, .move-button-icon {
        display: none;
      }
    }

    &.editable {
      width: 322px;
      margin-top: 15px;
    }

    .text {
      &.subtitle:not(:first-child) {
        margin-top: -.5rem;
      }

      &:not(:last-child) {
        margin-bottom: .7rem;
      }
    }

    &:not(:last-child) {
      margin-right: 2rem;
    }

    &:not(:last-child):not(.editable) {
      margin-right: 1rem;
    }
  }
</style>
